import type { NProcessFlow } from './PF.types'
import type { Stub_ILocalStorage } from '../Stub/Stub.localStorage'

export function PF_migrateFromLocalStorage(
    deps: {
        localStorage: Stub_ILocalStorage
    } = {
        localStorage,
    }
) {
    let processFlows: NProcessFlow.IProcessFlowV2[] = []

    try {
        const value = deps.localStorage.getItem('process_flow_v2')
        processFlows = JSON.parse(value)
        if (!Array.isArray(processFlows)) return []
    } catch (ex) {
        //
    }

    return processFlows
}
